module.exports = __webpack_public_path__ + "static/assets/613b5e1414ab2acb5600334d52f31924.svg";